<div class="modal-header">
  <h3 class="modal-title">
    Identity verification
  </h3>
  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="onClose()"
  >
  </button>
</div>

<div class="modal-body">
  <p>You've now completed your email identity verification.</p>
  <p>For future sign-ins, you can choose to use an authenticator app, which offers a faster and more secure way to verify your identity.</p>
  <p>Authenticator apps generate secure codes directly on your phone and work even without an internet connection, giving you a smoother and more reliable experience.</p>
  <p>To set up your authenticator app, go to the <strong>manage two factor authentication</strong> option under the <strong>my account</strong> section.</p>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-colour-white border-colour-grayscale-900"
    (click)="setupNow()"
  >
    Setup now
  </button>
  <button 
    type="button"
    class="btn btn-colour-white border-colour-grayscale-900"
    (click)="onClose()"
  >
    Setup later
  </button>
</div>
